import router from '@/router'
import { notification } from 'ant-design-vue'
import store from 'store'
import * as intranet from '@/services/axios/intranet'
import { merge } from 'lodash';

/**
 * segundo passo de autenticação MFA
 * com base no token, obtem-se informação do utilizador : currentAccount
 * get, insert, edits de informação levam sempre o token no header na chamada da API  
 */


const mapAuthProviders = {
    jwt: {
        //login: intranet.login,
        autenticacao_mfa_2: intranet.ws_autenticacao_mfa_2,
        // register: intranet.register,
        currentAccount: intranet.ws_currentAccount,
        logout: intranet.ws_logout,
    },
}

/*
const DEV = process.env.VUE_APP_AUTHENTICATED
    ? {
        id: '1',
        name: 'Tom Jones',
        role: '',
        roles: ['admin'],
        email: 'demo@sellpixels.com',
        avatar: '',
        authorized: true,
        accountFetchIsTouched: true,
    }
    : {}
*/
export default {
    namespaced: true,
    state: {
        nif: '',
        num_mec: '',
        uo_nome: '',
        uo_codigo: '',
        uo_codigo_2: '',
        uo_codigo_3: '',
        uo_responsavel: false,
        nome: '',
        num_telemovel: '',
        email: '',
        role: '',
        roles: [],
        authorized: false,
        loading: false,
        accountFetchIsTouched: false,
        //...DEV, // remove it, used for demo build
    },
    mutations: {
        SET_STATE(state, payload) {
            Object.assign(state, {
                ...payload,
            })
        },
    }, 
    actions: {
        /*
        LOGIN({ commit, dispatch, rootState }, { payload }) {
            const { email, password } = payload
            commit('SET_STATE', {
                loading: true,
            })

            const login = mapAuthProviders[rootState.settings.authProvider].login
            login(email, password).then(success => {
                if (success) {
                    dispatch('LOAD_CURRENT_ACCOUNT')
                    notification.success({
                        message: 'Bem-vindo',
                        description: 'Autenticação realizada com sucesso!',
                    })
                }
                if (!success) {
                    commit('SET_STATE', {
                        loading: false,
                    })
                    notification.warning({
                        message: 'Autenticação',
                        description: 'Autenticação inválida!',
                    })
                }
            })
        },
        */

        MFA_2({ commit, dispatch, rootState }, { payload }) {
            const { password, codigo } = payload
            commit('SET_STATE', {
                loading: true,
            })
            let tokenMFA = store.get('accessTokenMFA')
            const autenticacao_mfa_2 = mapAuthProviders[rootState.settings.authProvider].autenticacao_mfa_2
            autenticacao_mfa_2(password, codigo, tokenMFA).then(success => {
                let codigoErro = '0'
                if (success) {

                    codigoErro = success.codigo_erro
                    let token = success.output.token

                    if (codigoErro == '0') {
                        store.set('accessToken', token)
                        commit('token/SET_TOKEN', { token: token }, { root: true })

                        dispatch('LOAD_CURRENT_ACCOUNT')
                        notification.success({
                            message: 'Bem-vindo',
                            description: 'Autenticação realizada com sucesso!',
                        })
                    }
                }
                if (!success || codigoErro != '0') {
                    commit('SET_STATE', {
                        loading: false,
                    })
                    notification.warning({
                        message: 'Autenticação',
                        description: 'Autenticação inválida!',
                    })
                }
            })
        },
        LOAD_CURRENT_ACCOUNT({ commit, rootState }) {
            commit('SET_STATE', {
                loading: true,
            })

            const currentAccount = mapAuthProviders[rootState.settings.authProvider].currentAccount
            currentAccount().then(response => {
                if (response) {

                    //const { nif, email, nome } = response.output
                    const nif = response.output.user.nif
                    const num_mec = response.output.user.num_mec
                    const uo_nome = response.output.user.unidade_organica
                    const uo_codigo = response.output.user.unidade_organica_codigo
                    const uo_codigo_2 = response.output.user.unidade_organica_codigo_2
                    const uo_codigo_3 = response.output.user.unidade_organica_codigo_3
                    const uo_responsavel = response.output.user.unidade_organica_responsavel
                    const email = response.output.user.email
                    const nome = response.output.user.nome
                    const num_telemovel = response.output.user.num_telemovel
                    const role = ""
                    // se tiver esta role 
                    const roles = response.output.permissoes_lista

                    commit('SET_STATE', {
                        nif,
                        num_mec,
                        uo_nome,
                        uo_codigo,
                        uo_codigo_2,
                        uo_codigo_3,
                        uo_responsavel,
                        nome,
                        email,
                        role,
                        num_telemovel,
                        roles,  // lista de códigos com as roles relacionadas com o utilizador
                        authorized: true,
                    })
                }
                commit('SET_STATE', {
                    loading: false,
                })
            })
        },
        LOGOUT({ commit, rootState }) {
            const logout = mapAuthProviders[rootState.settings.authProvider].logout
            logout().then(() => {
                commit('SET_STATE', {
                    nif: '',
                    num_mec: '',
                    uo_nome: '',
                    uo_codigo: '',
                    uo_codigo_2: '',
                    uo_codigo_3: '',
                    uo_responsavel: false,
                    nome: '',
                    email: '',
                    role: '',
                    num_telemovel: '',
                    roles: '',
                    authorized: false,
                    loading: false,
                })
                router.push('/auth/login')
            })
        },
    },
    getters: {
        user: state => state,
    },
}
